import Config from '../config/index';
import { __initDB__, __clearDB__, __clearTable__ } from './db';
import { del } from './delete';

interface StorageConfig {
    clipboard: string,
    history: string
};

const storageConfig: StorageConfig = {
    clipboard: '++id,type,extendParams,data',
    history: '++id,paperId,actionId,type,extendParams,data'
};

export function init(): void {
    let paperId: number = Config.get({
        moduleName: 'base',
        key: 'paperId'
    });

    __initDB__(storageConfig);
    del({
        tableName: 'history',
        query: {
            paperId
        }
    });
}
